import { Button, Col, Row } from 'antd';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import iconoRegresar from '../../../img/icons/arrow-left-circle-fill.svg'

class HeaderModule extends React.Component {
    redireccionar = () => {
        if(this.props.redireccionar !== undefined)
            this.props.history.push(this.props.redireccionar);
        else
            this.props.history.goBack();
    }

    render() {
        return (
            <div>
                <Row type="flex" align="middle" gutter={[0, 16]} style={{'margin-top': '10px', 'margin-bottom':'10px'}}>
                    <Col xs={8} sm={8} md={8} lg={8} className='generic_header_module_return'>
                        <Button onClick={this.redireccionar} style={{backgroundColor:'transparent', color:'black'}}>
                            <img src={iconoRegresar} alt="Regresar" />
                            <span>Regresar</span>
                        </Button>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={8} 
                    className='generic_header_module_title'>
                        {this.props.title ? this.props.title : 'Usa la propiedad "title" para especificar un título.'}
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={8}></Col>
                </Row>
            </div>
        );
    }
}

export default withRouter(HeaderModule);